import { Layers } from "lucide-react";
import { Link } from "react-router-dom";


export default function Navbar() {
  return (
    <header className="w-full border-b border-gray-100 bg-white/80 backdrop-blur sticky top-0 z-50">
      <div className="max-w-7xl mx-auto flex items-center justify-between px-6 py-4">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center">
            <Layers className="text-white w-5 h-5" />
          </div>
          <div>
            <p className="font-bold text-gray-900 leading-tight">
              APIC <span className="text-indigo-600">ProtoHub</span>
            </p>
            <p className="text-[11px] tracking-wide text-gray-500 leading-tight">
              ANDHRA PRADESH
            </p>
          </div>
        </div>

        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-gray-700">
          <Link to="/facilities" className="hover:text-indigo-600">Explore Facilities</Link>
          <Link to="/machinemarketplace" className="hover:text-indigo-600">Machines</Link>
          <Link to="/howitworks" className="hover:text-indigo-600">How It Works</Link>
          <Link to="/app/dashboard" className="hover:text-indigo-600">For Innovators</Link>
          <Link to="/admin" className="hover:text-indigo-600">APIC Admin</Link>
        </nav>

        <div className="flex items-center gap-4">
          <Link to="/login" className="text-sm font-medium text-gray-700 hover:text-indigo-600">
            Login
          </Link>
          <Link
            to="/register"
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold px-5 py-2.5 rounded-xl transition"
          >
            Start Your Prototype
            <span aria-hidden="true">→</span>
          </Link>
        </div>
      </div>
    </header>
  );
}